import { canUseMarketing } from '@/utils/cookieConsent';

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let pixelScriptLoaded = false;

/**
 * Laddar Facebook Meta Pixel om användaren samtyckt till marknadsföring
 * och REACT_APP_META_PIXEL_ID är satt i build.
 * Sätts även på window.enableMetaPixel för CookieBanner.
 */
export function loadMetaPixelWhenConsented() {
  if (typeof window === 'undefined') return;
  if (!PIXEL_ID || !canUseMarketing()) return;
  if (pixelScriptLoaded || window.fbq) {
    pixelScriptLoaded = true;
    return;
  }

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
  pixelScriptLoaded = true;

  window.trackViewContent = (data) => {
    if (!window.fbq || !data) return;
    window.fbq('track', 'ViewContent', {
      content_ids: [String(data.id)],
      content_type: 'product',
      value: Number(data.price) || 0,
      currency: 'SEK',
    });
  };

  window.trackAddToCart = (data, quantity = 1) => {
    if (!window.fbq || !data) return;
    const q = Number(quantity) || 1;
    window.fbq('track', 'AddToCart', {
      content_ids: [String(data.id)],
      content_type: 'product',
      value: (Number(data.price) || 0) * q,
      currency: 'SEK',
    });
  };

  window.trackInitiateCheckout = ({ items, total }) => {
    if (!window.fbq || !items?.length) return;
    window.fbq('track', 'InitiateCheckout', {
      value: Number(total) || 0,
      currency: 'SEK',
      content_ids: items.map((i) => String(i.product_id)),
      num_items: items.reduce((s, i) => s + (i.quantity || 1), 0),
    });
  };

  window.trackPurchase = ({ id, total }) => {
    if (!window.fbq) return;
    window.fbq('track', 'Purchase', {
      value: Number(total) || 0,
      currency: 'SEK',
      content_ids: id ? [String(id)] : [],
    });
  };
}

if (typeof window !== 'undefined') {
  window.enableMetaPixel = loadMetaPixelWhenConsented;
}
